export const api = {
    createTodoDismissal: () => '/api/events/todos/dismiss/',
    deleteTodoDismissal: (todoId: string) => `/api/events/todos/dismiss/${todoId}/`
};
